module.exports = __webpack_public_path__ + "static/media/RyanCunningham-resume.bb384f8d.pdf";